import { useI18n } from '../i18n';
import { ORG_MANAGER, ORG_MEMBER, SqspUserType } from '../models/SqspUser';

export const useGetSqspUserRoleMap = () => {
  const { t } = useI18n();
  const getUserRole = (role: SqspUserType) => {
    const typeToRole = {
      [ORG_MANAGER]: t("Manager", {}, { project: 'enterprise-dashboard' }),
      [ORG_MEMBER]: t("Contributor", {}, { project: 'enterprise-dashboard' })
    };
    return typeToRole[role] ?? t("User", {}, { project: 'enterprise-dashboard' });
  };

  return { getUserRole };
};